"use client";

import { createContext, useContext, useState, type FC, type PropsWithChildren } from "react";

import { type SelectedDataType } from "@/components/maps/map-panel/map-panel-context";
import { useOnPathnameChange } from "@/hooks/use-on-pathname-change.hook";

interface SelectedDataTypeContextValue {
  selectedDataType: SelectedDataType | null;
  setSelectedDataType: (type: SelectedDataType | null) => void;
}

const SelectedDataTypeContext = createContext<SelectedDataTypeContextValue | null>(null);

export function useSelectedDataType() {
  const context = useContext(SelectedDataTypeContext);
  if (!context) {
    throw new Error("useSelectedDataType must be used inside <SelectedDataTypeProvider />");
  }
  return context;
}

export const SelectedDataTypeProvider: FC<PropsWithChildren> = ({ children }) => {
  const [selectedDataType, setSelectedDataType] = useState<SelectedDataType | null>(null);

  useOnPathnameChange(() => setSelectedDataType(null));

  const value: SelectedDataTypeContextValue = {
    selectedDataType,
    setSelectedDataType,
  };

  return (
    <SelectedDataTypeContext.Provider value={value}>
      {children}
    </SelectedDataTypeContext.Provider>
  );
};
